import { applyMiddleware, combineReducers, compose, createStore as _createStore, Reducer, StoreEnhancer } from 'redux';
import { ThunkAction, withExtraArgument } from 'redux-thunk';
import { IApplicationState, TReduxActions, TReduxStore } from '../../types/redux';
import { IConfig } from '@cian/config/shared';
import { ILogger } from '@cian/logger/shared';
import { buildersListReducer } from '../../reducers/builderReducer/reducer';
import { IHttpApi } from '@cian/http-api';
import { callReducer } from '../../reducers/call/reducer';
import { IBuildersList } from '../../types/builders';
import { createSimpleReducer } from './createSimpleReducer';

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 */

export interface IState {
  buildersList: IBuildersList;
  abGroup: number;
}
export interface IContext {
  config: IConfig;
  logger: ILogger;
  httpApi: IHttpApi;
}
export type IThunkActionCreator<T = void> = ThunkAction<T, IApplicationState, IContext, TReduxActions>;

export function createReduxStore(initialState: IApplicationState, context: IContext): TReduxStore {
  const reducers = combineReducers({
    buildersList: buildersListReducer,
    abGroup: createSimpleReducer(initialState.abGroup),
    call: callReducer,
    geo: createSimpleReducer(initialState.geo),
    buildersProjectsLocations: createSimpleReducer(initialState.buildersProjectsLocations),
    breadcrumbs: createSimpleReducer(initialState.breadcrumbs),
  }) as unknown as Reducer<IApplicationState, TReduxActions>;

  const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
  const storeEnchancers = composeEnhancers(applyMiddleware(withExtraArgument(context))) as unknown as StoreEnhancer;

  const createStore = (): TReduxStore => _createStore(reducers, initialState, storeEnchancers) as TReduxStore;

  return createStore();
}
